import { render, staticRenderFns } from "./vue-gantt.vue?vue&type=template&id=6c10472d"
import script from "./vue-gantt.vue?vue&type=script&lang=js"
export * from "./vue-gantt.vue?vue&type=script&lang=js"
import style0 from "./vue-gantt.vue?vue&type=style&index=0&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports